import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type Widget from "@/model/widget";

interface WidgetsState {
  byPlan: Record<string, Widget[]>;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: WidgetsState = {
  byPlan: {},
  status: "idle",
  error: null,
};

const widgetListSlice = createSlice({
  name: "widgetList",
  initialState,
  reducers: {
    setWidgets: (
      state,
      action: PayloadAction<{ byPlan: Record<string, Widget[]> }>,
    ) => {
      state.byPlan = action.payload.byPlan;
      state.status = "succeeded";
      state.error = null;
    },
    setWidgetsStatus: (
      state,
      action: PayloadAction<WidgetsState["status"]>,
    ) => {
      state.status = action.payload;
    },
    setWidgetsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.status = "failed";
    },
  },
});

export const { setWidgets, setWidgetsStatus, setWidgetsError } =
  widgetListSlice.actions;

export default widgetListSlice.reducer;
